<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>Search And Delete Jobs</h1>

      <form (ngSubmit)="search()" style="width: 100%">
        <div class="ui-g filterPanel form-group">
          <div class="ui-g-12 ui-md-4 ui-lg-2">
            <span class="md-inputfield filterItem">
              <input
                name="regNo"
                type="text"
                pInputText
                [(ngModel)]="filterVal.filters.jobNumber.value"
              />
              <label>Job Number</label>
            </span>
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-8">
            <button pButton type="submit" label="Search"></button>
            <button pButton type="button" label="Clear" (click)="clearFilter()"></button>
          </div>
        </div>
      </form>

      <p-table
        #dataTable
        selectionMode="single"
        [value]="page.items"
        [rows]="20"
        [responsive]="true"
        [paginator]="true"
        rowHover="true"
        [lazy]="true"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        [totalRecords]="page.total"
        (onLazyLoad)="onGridLazyLoad($event)"
        resizableColumns="true"
        [(selection)]="selectedJob"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="jobNumber">Job Number</th>
            <th pSortableColumn="from">From</th>
            <th pSortableColumn="to">To</th>
            <th pSortableColumn="latestPickupDate">Latest Pickup</th>
            <th pSortableColumn="latestDropOffDate">Latest Dropoff</th>
            <th pSortableColumn="movementType">Movement Type</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.jobNumber }}</td>
            <td>{{ inboxjobsService.addressStr(item.from) }}</td>
            <td>{{ inboxjobsService.addressStr(item.to) }}</td>
            <td>{{ item.latestPickupDate | datex : 'ddd DD MMM HH:mm' }}</td>
            <td>{{ item.latestDropOffDate | datex : 'ddd DD MMM HH:mm' }}</td>
            <td>{{ item.movementType }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!--- DATATABLE DEPRECATED ---
            <p-dataTabl #dataTable selectionMode="single" [value]="page.items" [rows]="20"
                         [responsive]="true" [paginator]="true" rowHover="true"
                         [lazy]="true" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3" [totalRecords]="page.total"
                         (onLazyLoad)="onGridLazyLoad($event)" resizableColumns="true"
                         [(selection)]="selectedJob">
                <p-column field="jobNumber" header="Job Number" [sortable]="tru" [editable]="false"></p-column>
                <p-column field="pickup" header="From" [sortable]="tru" [editable]="false">
                    <ng-template pTemplate="body" let-item="rowData">
                        {{ inboxjobsService.addressStr(item.from) }}
                    </ng-template>
                </p-column>
                <p-column field="dropoff" header="To" [sortable]="tru" [editable]="false">
                    <ng-template pTemplate="body" let-item="rowData">
                        {{ inboxjobsService.addressStr(item.to) }}
                    </ng-template>
                </p-column>
                <p-column field="latestPickupDate" header="Latest Pick-up" [sortable]="tru" [editable]="false">
                    <ng-template pTemplate="body" let-item="rowData">
                        {{ item.latestDropOffDate | datex:'ddd DD MMM HH:mm' }}
                    </ng-template>
                </p-column>
                <p-column field="latestDropOffDate" header="Latest Drop-Off" [sortable]="tru" [editable]="false">
                    <ng-template pTemplate="body" let-item="rowData">
                        {{ item.latestDropOffDate | datex:'ddd DD MMM HH:mm' }}
                    </ng-template>
                </p-column>
                <p-column field="movementType" header="Movement Type" [sortable]="tru" [editable]="false"></p-column>
            </p-dataTable>

            --->

      <div class="footerPanel ui-grid-row">
        <p-fileUpload
          name="file"
          url="/api/order/completedJobsCleanse"
          accept=".csv,.xls,.xlsx"
          (onUpload)="onCleanseUpload($event)"
          mode="basic"
          auto="true"
          withCredentials="true"
          chooseLabel="Cleanse Completed Jobs (CSV)"
        >
        </p-fileUpload>

        <p-fileUpload
          name="file"
          url="/api/order/cancelledAbortedJobsCleanse"
          accept=".csv,.xls,.xlsx"
          (onUpload)="onCleanseUpload($event)"
          mode="basic"
          auto="true"
          withCredentials="true"
          chooseLabel="Cleanse Cancelled/Aborted Jobs (CSV)"
        >
        </p-fileUpload>

        <p-fileUpload
          name="files"
          url="/api/order/getJobsForDeleteFromCsv"
          (onUpload)="onFileUpload($event)"
          withCredentials="true"
          [maxFileSize]="83886080"
          auto="true"
          chooseLabel="Filter Jobs By CSV"
          mode="basic"
        >
        </p-fileUpload>

        <button
          class="btn-to-right red-btn"
          type="button"
          (click)="deleteSelected(selectedJob)"
          icon="fa ui-icon-edit"
          label="Delete Selected"
          pButton
          [disabled]="!selectedJob"
        ></button>

        <button
          class="btn-to-right red-btn"
          type="button"
          (click)="deleteAll()"
          label="Delete All"
          pButton
          [disabled]="filterVal.filters.jobNumberList.value.length == 0"
        ></button>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog
  header="Confirmation"
  icon="fa-icon-circle"
  [style]="{ width: '425px' }"
  acceptLabel="Save"
  rejectLabel="Cancel"
></p-confirmDialog>
